module.exports = __webpack_public_path__ + "media/src/fonts/uni-neue/uni-neue-700-bold-italic-751a48d104da857f0f0f02da72c289b1.woff2";